<template>
  <v-container class="custom-container">
    <div class="big-chart-container px-5">
      <div
        v-show="loading"
        class="loader-container"
      >
        <v-progress-circular
          indeterminate
          color="green"
          width="2"
          size="38"
        />
      </div>
      <TankChart
        v-if="!loading"
        :key="key"
        class="px-2 py-4"
        :tank="tank"
        :records="records"
        :min-date="firstDay"
        :max-date="new Date(endDate * 1000)"
        :maintain-aspect-ratio="false"
      />
    </div>
    <v-layout
      px-5
    >
      <v-flex xs2>
        <v-text-field
          :value="customer.areaName"
          class="black-disabled"
          label="エリア"
          disabled
        />
      </v-flex>
      <v-flex
        xs2
        ml-3
      >
        <v-text-field
          :value="customer.name"
          class="black-disabled"
          label="顧客"
          disabled
        />
      </v-flex>
      <v-flex
        xs1
        ml-3
      >
        <v-text-field
          :value="tank.id"
          class="black-disabled"
          label="タンクID"
          disabled
        />
      </v-flex>
      <v-flex
        xs2
        ml-3
      >
        <v-text-field
          :value="tankTypeName"
          class="black-disabled"
          label="タンクタイプ"
          disabled
        />
      </v-flex>
      <v-spacer />
      <v-flex
        xs2
        class="date-input"
      >
        <DateInput
          :value="startDate"
          :min="serviceStart"
          :max="endDate"
          label="期間開始"
          @input="changeDate($event, 'start')"
        />
      </v-flex>
      <v-flex
        xs2
        ml-3
        class="date-input"
      >
        <DateInput
          :value="endDate"
          :min="startDate"
          label="期間終了"
          @input="changeDate($event, 'end')"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import * as moment from 'moment'
import { api } from '@/api.js'
import TankChart from './TankChart'
import { DateInput } from '../input'

const today = moment().endOf('day').unix()

export default {
  name: 'BigTankChart',
  components: {
    TankChart,
    DateInput
  },
  props: {
    customer: {
      type: Object,
      required: true
    },
    tank: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      key: 0,
      records: [],
      rangeEnd: today,
      endDate: today,
      startDate: today - 30 * 24 * 60 * 60,
      loading: true
    }
  },
  computed: {
    ...mapState('tankTypes', ['tankTypes']),
    tankTypeName () {
      return this.tankTypes.find(t => t.id === this.tank.tankType).tankName
    },
    serviceStart () {
      return moment('2020-10-01').unix()
    },
    firstDay () {
      return new Date(this.records[0]?.timestamp * 1000)
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    changeDate (dateString, caller) {
      if (!dateString || !caller) return

      switch (caller) {
        case 'start':
          this.startDate = moment(dateString).startOf('day').unix()
          break
        case 'end':
          this.endDate = moment(dateString).endOf('day').unix()
      }

      this.fetchData()
    },
    async fetchData () {
      this.loading = true

      try {
        const { record } = await api.getCustomerTank(
          this.customer.id, this.tank.id, {
            rangeFrom: this.startDate,
            rangeTo: this.endDate
          }
        )
        this.records = record.records
      } catch (err) {
        this.records = []
      } finally {
        this.loading = false
        ++this.key
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-container {
  width: 75vw;
  min-width: 600px;
  max-width: 125vh;
  height: 85vh;
  display: grid;
  grid-template-rows: 1fr min-content;
  grid-auto-flow: row;
  background-color: #fff;
}
.loader-container {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.black-disabled /deep/input {
  color: inherit;
}
.date-input {
  max-width: 120px;
}
</style>
